import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '@store/reducers';


const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {}
    }),
  devtools: true
});

export default store;
